import * as React from "react";

import { DataPie24Filled, DataPie24Regular } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const PulseMetricsApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "PulseMetrics" */ "./PulseMetricsApp");
    return { default: namedExport.PulseMetricsApp };
});

export const PulseMetrics: TeamAppConfig = {
    title: "Pulse Metrics",
    regularIcon: DataPie24Regular,
    filledIcon: DataPie24Filled,
    description: "Power BI-style dashboard displaying aggregated App Insights metrics across all Pulse apps.",
    team: "Pulse",
    publicId: "ExchangeOSP",
    owner: "OspOncall@microsoft.com",
    role: "*",
    tags: ["metrics", "dashboard", "app-insights"],
    app: PulseMetricsApp,
    path: "/PulseMetrics"
};
